import type { SVGProps } from 'react';

const SvgInstagramColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={24}
    viewBox='0 0 24 24'
    width={24}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.225 2H7.878C4.252 2 2.091 4.17 2.091 7.81v8.37c0 3.65 2.161 5.82 5.787 5.82h8.337c3.626 0 5.788-2.17 5.788-5.81V7.81C22.013 4.17 19.85 2 16.225 2'
      fill='#EFF0F3'
    />
    <path d='M12.012 15.88a3.88 3.88 0 1 0 0-7.76 3.88 3.88 0 0 0 0 7.76' fill='#923CBA' />
    <path d='M12.012 14.328a2.328 2.328 0 1 0 0-4.656 2.328 2.328 0 0 0 0 4.656' fill='#EFF0F3' />
    <path
      d='M17.013 7.5a1 1 0 0 1-.71-.29q-.135-.15-.21-.33a1 1 0 0 1-.08-.38c0-.13.03-.26.08-.38.05-.13.12-.23.21-.33.23-.23.58-.34.9-.27.07.01.13.03.19.06q.09.03.18.09c.05.03.1.08.15.12.09.1.16.2.21.33.05.12.08.25.08.38s-.03.26-.08.38q-.075.18-.21.33-.15.135-.33.21c-.12.05-.25.08-.38.08'
      fill='#923CBA'
    />
  </svg>
);
export default SvgInstagramColor;
